import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth-token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => {
    if (response.headers['x-ratelimit-limit']) {
      response.rateLimit = {
        limit: parseInt(response.headers['x-ratelimit-limit'], 10),
        remaining: parseInt(response.headers['x-ratelimit-remaining'], 10),
        reset: response.headers['x-ratelimit-reset'],
      }
    }
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth-token')
      window.dispatchEvent(new Event('auth-session-expired'))
    }

    if (error.response?.status === 429) {
      error.rateLimitExceeded = true
      error.resetAt = error.response.data?.resetAt
    }

    return Promise.reject(error)
  }
)
